import React from 'react'
import PropTypes from 'prop-types'
import css from '../../../patientCard.css'

const AddContactInfoButton = ({ contactInfoLabel, editContact }) => (
  <button onClick={editContact} className={css.contactAddButton}>
    Add {contactInfoLabel}
  </button>
)

AddContactInfoButton.PropTypes = {
  contactInfoLabel: PropTypes.string.isRequired,
  editContact: PropTypes.func.isRequired,
}

export default AddContactInfoButton



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/ContactField/EnabledField/ShowContact/AddContactInfoButton.js